import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../pages/styles.css';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const nav = document.querySelector('.navbar');
      if (nav && !nav.contains(event.target) && isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const navLinks = [
    { path: '/', label: 'Home', icon: 'fa-home' },
    { path: '/services', label: 'Services', icon: 'fa-code' },
    { path: '/about', label: 'About', icon: 'fa-info-circle' },
    { path: '/portfolio', label: 'Portfolio', icon: 'fa-folder-open' },
    { path: '/contact', label: 'Contact', icon: 'fa-envelope' },
    { path: '/reviews', label: 'Reviews', icon: 'fa-star' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar" role="navigation" aria-label="Main navigation">
      <div className="brand">
        <Link 
          to="/" 
          className="brand-link" 
          onClick={() => setIsOpen(false)}
          aria-label="Raffcodes - Home"
        >
          <div className="brand-identity">
            <img 
              src="/images/raffcodes-logo.png" 
              alt="Raffcodes - IT Solutions Logo" 
              className="nav-logo"
              loading="eager"
              width="150"
              height="50"
            />
            <span className="brand-name">Raffcodes</span>
          </div>
        </Link>

        <button 
          className="menu-toggle" 
          onClick={() => setIsOpen(!isOpen)}
          aria-label={isOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isOpen}
          aria-controls="nav-links"
        >
          <span className={`hamburger-icon ${isOpen ? 'open' : ''}`}>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </span>
        </button>
      </div>

      <div 
        className={`nav-links ${isOpen ? 'open' : ''}`} 
        id="nav-links"
        role="menu"
      >
        {navLinks.map(({ path, label, icon }) => (
          <Link
            key={path}
            to={path}
            className={`nav-link ${isActive(path) ? 'active' : ''}`}
            onClick={() => setIsOpen(false)}
            role="menuitem"
            aria-current={isActive(path) ? 'page' : undefined}
          >
            <i className={`fas ${icon}`} aria-hidden="true"></i>
            <span>{label}</span>
          </Link>
        ))}
        
        {/* Contact CTA in mobile menu */}
        <Link 
          to="/contact" 
          className="nav-link nav-cta"
          onClick={() => setIsOpen(false)}
          role="menuitem"
        >
          <i className="fas fa-paper-plane" aria-hidden="true"></i>
          <span>Get Started</span>
        </Link>
      </div>
    </nav>
  );
}